import { render, staticRenderFns } from "./StatusWidget.vue?vue&type=template&id=4597dc80"
import script from "./StatusWidget.vue?vue&type=script&lang=js"
export * from "./StatusWidget.vue?vue&type=script&lang=js"
import style0 from "./StatusWidget.vue?vue&type=style&index=0&id=4597dc80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VIcon,VTooltip})
